import { render, staticRenderFns } from "./host-common-contact.vue?vue&type=template&id=36ca7a89&scoped=true&"
import script from "./host-common-contact.vue?vue&type=script&lang=js&"
export * from "./host-common-contact.vue?vue&type=script&lang=js&"
import style0 from "./host-common-contact.vue?vue&type=style&index=0&id=36ca7a89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca7a89",
  null
  
)

export default component.exports